import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ApiProvider } from './context/ApiProvider';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <ApiProvider>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <App />
    </ApiProvider>
  </BrowserRouter>
);
